import Component from '@cell/cell-core/component/component';
import './filters-mobile.scss';

class FiltersMobile extends Component {
  constructor() {
    super();

    this.handleFilterRemoveAllClick = this.handleFilterRemoveAllClick.bind(this);
    this.handleFilterSubmitAllClick = this.handleFilterSubmitAllClick.bind(this);
  }

  componentDidMount() {
    this.on('c-button.click.remove-all-filters', this.handleFilterRemoveAllClick);
    this.on('c-button.click.submit-all-filters', this.handleFilterSubmitAllClick);
  }

  handleFilterRemoveAllClick() {
    this.emit('remove-all-filters', { url: this.parsedDataset.urlToRemoveAll });
  }

  handleFilterSubmitAllClick() {
    this.querySelector('.Drawer').close();
  }
}

customElements.define('filters-mobile', FiltersMobile);
